import {createContext} from "react";

const CompanyScreen = createContext<any>(null);

export default CompanyScreen;
